// extracted by mini-css-extract-plugin
export default {"root":"style_root__X9chZ","header":"style_header__K3RFO","existNumber":"style_existNumber__VJr2e"};